<template>
  <footer>
    <aside>
      <Logo 
        :is-dark="true"
        :is-black="true" />

      <article>
        <a href="https://www.linkedin.com/company/ryomaweb/about" target="_blank">
          <font-awesome-icon :icon="['fab', 'linkedin']" />
        </a>
        <a href="https://twitter.com/RyomaWeb">
          <font-awesome-icon :icon="['fab', 'twitter']" target="_blank" />
        </a>
      </article>

      <article>
        <router-link :to="{name: 'contacts'}">Contact Us</router-link>
        <a href="#">Terms &amp; Conditions</a>
      </article>
    </aside>
  </footer>
</template>

<script>
import Logo from "@/components/Logo.vue";

export default {
  name: "main-footer",
  components: {
    Logo
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/mixins.scss";

footer {
  background: $gray_dark_2;

  aside {
    background: black;

    @include respond-to(tablet) {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      grid-column-gap: 2vmin;
      > figure {
        grid-column: 2 /span 2;
      }
      > article {
        grid-column: 6 /span 2;

        &:last-of-type {
          grid-column: 8 /span 4;
          justify-self:flex-end;
        }
      }
    }
  }

  // figure {
  //   margin: 0 auto;
  // }

  article {
    padding: 5vmin 0;
    @include center-content(row);
    color: white;

    a {
      font-size: 5vmin;

      &:not(:last-child) {
        margin-right: $small_vmin;
      }

      @include respond-to(tablet) {
        font-size: inherit;
      }
    }
  }
}
</style>